import { createSlice } from "@reduxjs/toolkit";
import {
  fetchCashFlowsThunk,
  createCashFlowThunk,
  updateCashFlowThunk,
  deleteCashFlowThunk,
} from "./cashFlow.thunk";

const initialState = {
  cashFlows: [],
  loading: false,
  error: null,
  total: 0,
  page: 1,
  pages: 1,
};

const cashFlowSlice = createSlice({
  name: "cashFlow",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCashFlowsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCashFlowsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.cashFlows = action.payload?.data || [];
        state.total = action.payload?.total || 0;
        state.page = action.payload?.page || 1;
        state.pages = action.payload?.pages || 1;
      })
      .addCase(fetchCashFlowsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(createCashFlowThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(createCashFlowThunk.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(createCashFlowThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(updateCashFlowThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateCashFlowThunk.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(updateCashFlowThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(deleteCashFlowThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteCashFlowThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.cashFlows = state.cashFlows.filter((cf) => cf._id !== action.payload.id);
        state.total = Math.max(0, state.total - 1);
      })
      .addCase(deleteCashFlowThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default cashFlowSlice.reducer;
